import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../admin/AuthContext';

const PROPERTY_TYPES = [
  { value: 'bnb', label: 'B&B' },
  { value: 'affittacamere', label: 'Affittacamere' },
  { value: 'casa_vacanze', label: 'Casa vacanze' },
  { value: 'agriturismo', label: 'Agriturismo' },
];

function formatDetail(detail) {
  if (!detail) return 'Registrazione non riuscita';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return String(detail);
}

const inputCls =
  'w-full rounded-lg border border-paelbi-line bg-white px-3 py-2.5 text-sm text-paelbi-ink outline-none focus:border-paelbi-brown';

export function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', property_name: '', property_type: 'bnb' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await register(form);
      navigate('/onboarding/wizard', { replace: true });
    } catch (e2) {
      setErr(formatDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-paelbi-bg px-4 py-10">
      <div className="w-full max-w-md rounded-2xl border border-paelbi-line bg-white p-8 shadow-card" data-testid="register-card">
        <div className="mb-6 text-center">
          <h1 className="font-display text-2xl text-paelbi-ink">Crea la tua struttura</h1>
          <p className="mt-1 text-sm text-paelbi-ink/60">Registrati gratuitamente e inizia in pochi minuti.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Il tuo nome</label>
            <input value={form.name} onChange={set('name')} required minLength={2} className={inputCls} data-testid="register-name" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Nome struttura</label>
            <input value={form.property_name} onChange={set('property_name')} required minLength={2}
              placeholder="Es. Villa Bellavista" className={inputCls} data-testid="register-property-name" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Tipo di struttura</label>
            <select value={form.property_type} onChange={set('property_type')} className={inputCls} data-testid="register-property-type">
              {PROPERTY_TYPES.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Email</label>
            <input type="email" value={form.email} onChange={set('email')} required className={inputCls} data-testid="register-email" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Password</label>
            <input type="password" value={form.password} onChange={set('password')} required minLength={6}
              className={inputCls} data-testid="register-password" />
          </div>
          {err && <p className="text-sm text-red-600" data-testid="register-error">{err}</p>}
          <button disabled={busy} type="submit"
            className="h-11 w-full rounded-btn bg-paelbi-brown font-semibold text-white transition-colors hover:bg-paelbi-brown-dark disabled:opacity-60"
            data-testid="register-submit">
            {busy ? 'Creazione...' : 'Crea struttura gratis'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-paelbi-ink/60">
          Hai già un account? <a href="/admin/login" className="font-semibold text-paelbi-brown">Accedi</a>
        </p>
      </div>
    </div>
  );
}

export default Register;
